var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c(
        "div",
        { staticClass: "header" },
        [
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.maskShow,
                expression: "maskShow"
              }
            ],
            staticClass: "msk"
          }),
          _vm._v(" "),
          _c("div", { staticClass: "nav" }, [
            _c("div", [
              !_vm.leftShow
                ? _c("img", {
                    staticClass: "logo",
                    attrs: {
                      src: require("@/assets/images/login/ip_logo.png"),
                      alt: "logo"
                    },
                    on: { click: _vm.toHomePage }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cjt-fr flex bar-right" },
              [_c("UserInfo")],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              attrs: {
                title: null,
                footer: null,
                width: "60%",
                centered: "",
                destroyOnClose: ""
              },
              on: { ok: _vm.handleOk },
              model: {
                value: _vm.visible,
                callback: function($$v) {
                  _vm.visible = $$v
                },
                expression: "visible"
              }
            },
            [
              _c(
                "div",
                { staticClass: "pagePosition-index-message" },
                [
                  _c("h2", [_vm._v(_vm._s(_vm.messageData.title))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _vm.messageData.url
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.messageData.url,
                              target: "_blank"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: { "max-width": "100%" },
                              attrs: { src: _vm.messageData.files }
                            })
                          ]
                        )
                      : _c("img", {
                          staticStyle: { "max-width": "100%" },
                          attrs: { src: _vm.messageData.files }
                        })
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.visible = false
                        }
                      }
                    },
                    [_vm._v("确认")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bd8011f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bd8011f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/HeaderNew.vue
// module id = null
// module chunks = 